import React, { FC, useCallback, useMemo, useState } from 'react';
import BulkTransferFromStockLocationModal from './BulkTransferFromStockLocationModal';
import TransferToLocationReceivedEquipmentBulk from './TransferToLocationReceivedEquipmentBulk';
import { Button, Dropdown, Menu } from 'antd';
import { connect } from 'react-redux';
import { bulkTransferEquipmentsPerStockLocactionForSupplier } from '../../thunks/equipment_per_stock_locations_thunks';

const TransferEPSLButton: FC<any> = ({
	stockLocationId,
	onTransferSuccess,
	selectedRecords,
	buttonSize = 'large',
	buttonType = 'primary',
	ghost,

	bulkTransfer,
}): React.ReactElement => {
	const [transferLoading, setTransferLoading] = useState(false);

	const [transferModalVisible, setTransferModalVisible] = useState(null);
	const [transferBulkToLocationVisible, setTransferBulkToLocationVisible] = useState(null);

	const _onTransferClick = (type) => setTransferModalVisible(type);

	const _hideTransferModal = () => setTransferModalVisible(null);

	const onTransferEquipmentsSuccess = useCallback(() => {
		_hideTransferModal();
		setTransferBulkToLocationVisible(false);
		onTransferSuccess();
	}, [onTransferSuccess]);

	const onTransfer = useCallback(
		(values) => {
			const updatedRecords = selectedRecords.map((record) => ({
				...record,
				id: `${record.id}`,
				stockLocationId: values.toStockLocationId,
				...(values.transferNote && { transferNote: values.transferNote }),
			}));

			bulkTransfer(updatedRecords).then(() => onTransferEquipmentsSuccess());
		},
		[bulkTransfer, selectedRecords, onTransferEquipmentsSuccess]
	);

	const transferMenu = useMemo(
		() => (
			<Menu>
				<Menu.Item onClick={() => _onTransferClick('stockLocation')}>To Stock Location</Menu.Item>
				<Menu.Item
					onClick={() => {
						if (selectedRecords.length < 2) {
							_onTransferClick('location');
						} else {
							setTransferBulkToLocationVisible(true);
							setTransferLoading(true);
						}
					}}
				>
					To Location
				</Menu.Item>
			</Menu>
		),
		[selectedRecords]
	);

	return (
		<>
			<Dropdown overlay={transferMenu}>
				<Button
					className="ml-2"
					size={buttonSize}
					type={buttonType}
					ghost={ghost}
					loading={transferLoading}
				>
					Transfer
				</Button>
			</Dropdown>
			{transferModalVisible && (
				<BulkTransferFromStockLocationModal
					onCancel={_hideTransferModal}
					stockLocationId={stockLocationId}
					selectedEpsls={selectedRecords}
					onTransferToSL={onTransfer}
					onSuccess={onTransferEquipmentsSuccess}
					locationType={transferModalVisible}
				/>
			)}
			{transferBulkToLocationVisible && (
				<TransferToLocationReceivedEquipmentBulk
					selectedRecords={selectedRecords}
					onSuccess={onTransferEquipmentsSuccess}
					onClose={() => setTransferBulkToLocationVisible(false)}
					transferInitiated={() => setTransferLoading(false)}
				/>
			)}
		</>
	);
};

const mapDispatchToProps = (dispatch) => ({
	bulkTransfer: (entities) =>
		dispatch(bulkTransferEquipmentsPerStockLocactionForSupplier(entities)),
});

export default connect(null, mapDispatchToProps)(TransferEPSLButton);
